import { MatDialog } from '@angular/material/dialog';
import { WebSocketService, WebSocketServiceConfig, WSServiceFactory } from 'types';
import { CameraService, CameraServiceBase } from './camera.service';
import { HWServiceConfig } from './hw-service-config';
import { PortraitService, PortraitServiceBase } from './portrait.service';
import { HWCameraServiceStub, HWPortraitServiceStub } from './stubs/hw-camera-service-stub';
import { HWCameraWebSocketStub } from './stubs/hw-camera-websocket-stub';
import { HWPassportWebSocketStub } from './stubs/hw-passport-websocket-stub';
import { HWPortraitWebSocketStub } from './stubs/hw-portrait-websocket-stub';

export function webSocketFactory(mock: boolean): WSServiceFactory {
  return (config: WebSocketServiceConfig) => {
    switch (mock ? config.protocol : null) {
      case 'mrtd-ws':
        return new HWPassportWebSocketStub(config);
      case 'image-ws':
        return new HWPortraitWebSocketStub(config);
      case 'camera-ws':
        return new HWCameraWebSocketStub(config);
      default:
        return new WebSocketService(config);
    }
  };
}

export function portraitServiceFactory(mock: boolean, config: HWServiceConfig, wsFactory: WSServiceFactory): PortraitServiceBase {
  return mock ? new HWPortraitServiceStub() : new PortraitService(config, wsFactory);
}

export function cameraServiceFactory(
  mock: boolean,
  config: HWServiceConfig,
  wsFactory: WSServiceFactory,
  dialog: MatDialog,
): CameraServiceBase {
  return mock ? new HWCameraServiceStub(config, wsFactory, dialog) : new CameraService(config, wsFactory);
}
